import i18n from 'i18next';
import { checkServiceProvider } from './serviceProviderConfig';

export const headerNames = {
  TOTALDRIVERS: i18n.t('dashboard.header.TOTALDRIVERS'),
  ONDUTY: i18n.t('dashboard.header.ONDUTY'),
  DRIVING: i18n.t('dashboard.header.DRIVING'),
  SLEEPER: i18n.t('dashboard.header.SLEEPER'),
  OFFDUTY: i18n.t('dashboard.header.OFFDUTY'),
  TOTALTRUCKS: i18n.t('dashboard.header.TOTALTRUCKS'),
  AVAILABLETRUCKS: i18n.t('dashboard.header.AVAILABLETRUCKS'),
  INSHOP: i18n.t('dashboard.header.INSHOP'),
  OUTOFSERVICE: i18n.t('dashboard.header.OUTOFSERVICE'),
};

export const driverStatusColumns = [
  {
    id: 'fullName',
    disablePadding: false,
    label: i18n.t('vehicles.fullName'),
  },
  {
    id: 'lastKnownLocation',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastKnownLocation'),
  },
  {
    id: 'unitName',
    numeric: true,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.unit'),
  },
  {
    id: 'driveTimeRemaining',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.driveTimeRemaining'),
  },
  {
    id: 'timeUntilBreak',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.timeUntilBreak'),
  },
  {
    id: 'onDutyTimeRemaining',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.onDutyTimeRemaining'),
  },

  {
    id: 'dutyCycleRemaining',
    numeric: true,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.dutyCycleRemaining'),
  },
  {
    id: 'currentStatus',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.currentStatus'),
  },
  {
    id: 'engineSpeed',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.engineSpeed'),
  },
  {
    id: 'lastUpdated',
    numeric: true,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastUpdated'),
  },
];

export const getELDStatusIcon = (status) => {
  const statusMap = {
    NOT_STARTED: 'eld-inActive',
    TAMPERED: 'eld-inActive',
    DISCONNECTED: 'eld-inActive',
    CONNECTED: 'eld-active',
    '': 'eld-loggedOut',
  };
  return statusMap[status] || '';
};

export const developerRequestColumns = [
  {
    id: 'description',
    disablePadding: false,
    label: i18n.t('common.description'),
    needSorting: true,
  },
  {
    id: 'date',
    disablePadding: false,
    label: i18n.t('common.date'),
    needSorting: true,
  },
  {
    id: 'phone',
    disablePadding: false,
    label: i18n.t('common.phone'),
    needSorting: true,
  },
  { id: 'actions' },
];

export const dailyLogColumns = [
  {
    id: 'fullName',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.fullName'),
  },
  {
    id: 'hoursDriving',
    disablePadding: false,
    label: i18n.t('common.hoursDriving'),
  },
  {
    id: 'phone',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.phone'),
  },

  {
    id: 'hours',
    disablePadding: false,
    label: i18n.t('common.hours'),
  },
];

export const monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const driverStatusTableColumns = [
  { id: 'name', disablePadding: false, label: i18n.t('Driver Name') },
  {
    id: 'unitName',
    numeric: true,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.unit'),
  },
  {
    id: 'driveTimeRemaining',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.driveTime'),
  },
  {
    id: 'onDutyTimeRemaining',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.onDutyTime'),
  },
  {
    id: 'dutyCycleRemaining',
    numeric: true,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.dutyCycleRemaining'),
  },
  {
    id: 'lastKnownLocation',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastKnownLocation'),
  },
  {
    id: 'lastUpdated',
    numeric: true,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastUpdated'),
  },
  {
    id: 'currentStatus',
    disablePadding: false,
    label: i18n.t('Logs'),
  },
  ...(checkServiceProvider('config_driverStatusTableColumns', window?.$environment?.SERVICE_PROVIDER, false) || []),
];

export const overviewColumns = [
  {
    id: 'companyName',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radiusComplianceAlerts.company'),
    needSorting: true,
  },
  {
    id: 'radius',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radius'),
    needSorting: true,
  },
  {
    id: 'severityGraph',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.severity'),
    needSorting: true,
  },
  {
    id: 'lossControl',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radiusComplianceAlerts.lossControl'),
    needSorting: true,
  },
  {
    id: 'underwriter',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radiusComplianceAlerts.underwriter'),
    needSorting: true,
  },
];

export const recentAccidentsColumns = [
  {
    id: 'fullName',
    numeric: false,
    disablePadding: false,
    label: i18n.t('vehicles.fullName'),
  },
  {
    id: 'phone',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.phone'),
  },
  {
    id: 'report',
    disablePadding: false,
    label: i18n.t('accidents.accidentReport'),
  },
];
